var _style, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:none;stroke:#333333;stroke-linejoin:round;stroke-miterlimit:2;}\n\t.st3{fill:none;stroke:#333333;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:2;}\n\t.st4{fill:#333333;}\n\t.st5{fill:#EAF0F5;}\n\t.st6{fill:#7CB2FF;}\n\t.st7{fill:#FFB12F;}\n\t.st8{fill:#FFD875;}\n\t.st9{fill:#68A7F2;}\n\t.st10{fill:#FFFFFF;}\n\t.st11{fill:none;stroke:#7CB2FF;stroke-linecap:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6.5,6.5h11C18.3,6.5,19,7.2,19,8v12c0,0.8-0.7,1.5-1.5,1.5h-11C5.7,21.5,5,20.8,5,20V8 C5,7.2,5.7,6.5,6.5,6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M15,9.5v-4c0-1.7-1.3-3-3-3l0,0c-1.7,0-3,1.3-3,3v4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M15,17c0,0-1-1.5-3-1.5S9,17,9,17"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 9,
    cy: 13,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 15,
    cy: 13,
    r: 0.8
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M22.4,7.3c-0.9-1-2.3-1-3.3-0.2c0,0-0.5,0.5-1.3,1.2c-0.1-0.3-0.2-0.7-0.4-1c-0.5-0.6-1.2-0.9-2-0.9 c0.4-0.3,0.8-0.7,1.1-1c1-0.8,1.1-2.3,0.3-3.3c-0.8-1-2.3-1.1-3.3-0.3c0,0-2.7,2.3-5.4,4.5C6.7,7.6,5.4,8.7,4.3,9.6 c-2.3,2-2.5,2.1-2.5,3.2c0,1.1,0.8,2.1,1.9,2.3c-2.3,1.8-2.4,2-2.4,3.1c0,1.3,1,2.3,2.3,2.3c0.6,0,1.2-0.3,1.6-0.7 c0.3-0.2,1.4-1.1,2.8-2.3c0,0.1,0,0.3,0,0.5c0,1.3,1,2.3,2.3,2.3c0.7,0,1.3-0.3,1.7-0.8c0.7-0.7,6.5-5.9,10.1-9.1 C23.2,9.8,23.3,8.3,22.4,7.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 16,
    cy: 18.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 9.6,
    cy: 18.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M17,18.8c0,0.6-0.5,1.1-1.1,1.1c-0.1,0-0.2,0-0.3-0.1c-0.4-0.1-0.7-0.5-0.7-1c0-0.6,0.5-1.1,1.1-1.1h0 C16.6,17.8,17,18.2,17,18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M10.7,18.9c0,0.6-0.5,1.1-1.1,1.1c-0.1,0-0.3,0-0.4-0.1c-0.4-0.2-0.7-0.5-0.7-1c0-0.6,0.5-1.1,1.1-1.1 c0,0,0,0,0,0C10.2,17.9,10.7,18.3,10.7,18.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M16.7,18.7c0,0.6-0.5,1.1-1.1,1.1h0c-0.4-0.1-0.7-0.5-0.7-1c0-0.6,0.5-1.1,1.1-1.1h0 C16.4,17.9,16.7,18.3,16.7,18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M10.4,18.8c0,0.6-0.5,1.1-1.1,1.1c0,0,0,0-0.1,0c-0.4-0.2-0.7-0.5-0.7-1c0-0.6,0.5-1.1,1.1-1.1c0,0,0,0,0,0 C10.1,18,10.4,18.4,10.4,18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M20.2,9.7l-1.6,4.9c-0.2,0.7-0.9,1.1-1.6,1.1h-8c-0.2,0-0.5,0-0.7-0.1l0.3-0.4c0-0.1,0.1-0.1,0.1-0.2 c0.1-0.1,0.1-0.3,0-0.4L7.3,8.2c0.2-0.2,0.6-0.4,1-0.4c0,0,0.1,0,0.1,0h10.5c0.1,0,0.2,0,0.3,0h0C20,8,20.5,8.8,20.2,9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M18.8,9.7l-1.6,4.9c-0.2,0.7-0.9,1.1-1.6,1.1h-8c-0.2,0-0.5,0-0.7-0.1l0.3-0.4c0-0.1,0.1-0.1,0.1-0.2 c0.1-0.1,0.1-0.3,0-0.4L5.9,8.2c0.2-0.2,0.6-0.4,1-0.4c0,0,0.1,0,0.1,0h10.5c0.1,0,0.2,0,0.3,0h0C18.6,8,19.1,8.8,18.8,9.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M18.1,17.7c0,0.3-0.2,0.5-0.5,0.5H7.4c-0.5,0-1-0.3-1.2-0.7C6,17,6,16.5,6.3,16.2l0.4-0.7L7,15 c0.1-0.2,0.2-0.4,0.1-0.6L5.5,8.2L5.3,7.4H3.6c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h2.1c0.2,0,0.4,0.1,0.5,0.4l0.3,1 L8,14.2c0.1,0.5,0,1-0.2,1.4l-0.1,0.1l-0.6,1C7,16.8,7,16.9,7,17c0.1,0.1,0.2,0.2,0.3,0.2h10.3C17.9,17.2,18.1,17.4,18.1,17.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M18.5,17.7c0,0.3-0.2,0.5-0.5,0.5H7.7c-0.5,0-1-0.3-1.2-0.7c-0.2-0.4-0.2-0.9,0.1-1.3L7,15.5L7.3,15 c0.1-0.2,0.2-0.4,0.1-0.6L5.9,8.2L5.7,7.4H4c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h2.1c0.2,0,0.4,0.1,0.5,0.4l0.3,1 l1.6,6.4c0.1,0.5,0,1-0.2,1.4l-0.1,0.1l-0.6,1c-0.1,0.1-0.1,0.2,0,0.3c0.1,0.1,0.2,0.2,0.3,0.2H18 C18.3,17.2,18.5,17.4,18.5,17.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M8.7,18.2L9.4,19c0.1,0.1,0.3,0.1,0.4,0l0.7-0.8c0.1-0.2,0-0.4-0.2-0.4H8.9C8.7,17.8,8.6,18,8.7,18.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M15.1,18.1l0.6,0.8c0.1,0.1,0.3,0.1,0.4,0l0.7-0.8c0.1-0.2,0-0.4-0.2-0.4h-1.3 C15.1,17.6,14.9,17.9,15.1,18.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M15.6,10.6H9.6c-0.2,0-0.3-0.1-0.3-0.3v0c0-0.2,0.1-0.3,0.3-0.3h6.1c0.2,0,0.3,0.1,0.3,0.3v0 C15.9,10.5,15.8,10.6,15.6,10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M15.6,13.1H9.6c-0.2,0-0.3-0.1-0.3-0.3v0c0-0.2,0.1-0.3,0.3-0.3h6.1c0.2,0,0.3,0.1,0.3,0.3v0 C15.9,13,15.8,13.1,15.6,13.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 12.8,
    y1: 2.9,
    x2: 12.8,
    y2: 5.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 14.9,
    y1: 6.4,
    x2: 16.5,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 10.7,
    y1: 6.4,
    x2: 9.1,
    y2: 4
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M20.3,5.5c-0.1,0.1-0.2,0.1-0.3,0l-0.4-0.4c-0.1-0.1-0.1-0.2,0-0.3c0.1-0.1,0.2-0.1,0.3,0l0.4,0.4 C20.4,5.3,20.4,5.4,20.3,5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M21.3,6.6c-0.1,0.1-0.2,0.1-0.3,0l-0.4-0.4c-0.1-0.1-0.1-0.2,0-0.3c0.1-0.1,0.2-0.1,0.3,0l0.4,0.4 C21.4,6.4,21.4,6.5,21.3,6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M21.4,5.2L21,5.5c-0.1,0.1-0.2,0.1-0.3,0c-0.1-0.1-0.1-0.2,0-0.3l0.4-0.4c0.1-0.1,0.2-0.1,0.3,0 C21.5,4.9,21.5,5.1,21.4,5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M20.3,6.2l-0.4,0.4c-0.1,0.1-0.2,0.1-0.3,0c-0.1-0.1-0.1-0.2,0-0.3L20,5.8c0.1-0.1,0.2-0.1,0.3,0 C20.4,5.9,20.4,6.1,20.3,6.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M2.3,7.8c-0.1,0.1-0.2,0-0.2,0L1.7,7.4c-0.1-0.1-0.1-0.2,0-0.2c0.1-0.1,0.2,0,0.2,0l0.3,0.3 C2.3,7.6,2.3,7.8,2.3,7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M3.1,8.7c-0.1,0.1-0.2,0-0.2,0L2.6,8.4c-0.1-0.1-0.1-0.2,0-0.2c0.1-0.1,0.2,0,0.2,0l0.3,0.3 C3.2,8.6,3.2,8.7,3.1,8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M3.1,7.6L2.8,7.9c-0.1,0.1-0.2,0-0.2,0c-0.1-0.1-0.1-0.2,0-0.2l0.3-0.3c0.1-0.1,0.2,0,0.2,0 C3.1,7.4,3.1,7.5,3.1,7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M2.3,8.3L2,8.6c-0.1,0.1-0.2,0-0.2,0c-0.1-0.1-0.1-0.2,0-0.2L2,8.1c0.1-0.1,0.2,0,0.2,0S2.3,8.3,2.3,8.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M20.6,15.5c-0.1,0-0.1,0-0.2,0l-0.2-0.3c0-0.1,0-0.1,0-0.2s0.1,0,0.2,0l0.2,0.3 C20.7,15.3,20.7,15.4,20.6,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M21.2,16.1c-0.1,0-0.1,0-0.2,0l-0.2-0.3c0-0.1,0-0.1,0-0.2s0.1,0,0.2,0l0.2,0.3 C21.3,16,21.3,16.1,21.2,16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M21.3,15.3L21,15.5c-0.1,0-0.1,0-0.2,0c0-0.1,0-0.1,0-0.2l0.3-0.2c0.1,0,0.1,0,0.2,0 C21.3,15.1,21.3,15.2,21.3,15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M20.6,15.9l-0.3,0.2c-0.1,0-0.1,0-0.2,0c0-0.1,0-0.1,0-0.2l0.3-0.2c0.1,0,0.1,0,0.2,0 C20.7,15.7,20.7,15.8,20.6,15.9z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M7,18.8l0.3-0.1c0.1,0,0.1-0.2,0-0.3L7,18.4c-0.3-0.1-0.6-0.3-0.6-0.6l-0.1-0.3c0-0.2-0.2-0.2-0.3,0L6,17.7 c-0.1,0.3-0.3,0.6-0.6,0.6l-0.3,0.1c-0.1,0-0.1,0.2,0,0.3l0.3,0.1c0.3,0.1,0.6,0.3,0.6,0.6l0.1,0.3c0,0.2,0.2,0.2,0.3,0l0.1-0.3 C6.5,19.1,6.7,18.8,7,18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M7.1,3.6l0.3-0.1c0.2,0,0.2-0.3,0-0.3L7.1,3.1C6.7,3.1,6.5,2.8,6.4,2.5L6.4,2.1c0-0.2-0.3-0.2-0.3,0L6,2.5 C5.9,2.8,5.7,3.1,5.3,3.1L5,3.2c-0.2,0-0.2,0.3,0,0.3l0.3,0.1C5.7,3.7,5.9,3.9,6,4.3l0.1,0.3c0,0.2,0.3,0.2,0.3,0l0.1-0.3 C6.5,3.9,6.7,3.7,7.1,3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M16.7,21.7l0.2,0c0.1,0,0.1-0.1,0-0.2l-0.2,0c-0.2,0-0.3-0.2-0.4-0.4l0-0.2c0-0.1-0.1-0.1-0.2,0l0,0.2 c0,0.2-0.2,0.3-0.4,0.4l-0.2,0c-0.1,0-0.1,0.1,0,0.2l0.2,0c0.2,0,0.3,0.2,0.4,0.4l0,0.2c0,0.1,0.1,0.1,0.2,0l0-0.2 C16.4,21.9,16.5,21.8,16.7,21.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartEmpty);
export default __webpack_public_path__ + "static/media/cart_empty.60424ea28d8bbc2d2bbb729e00e7e5f4.svg";
export { ForwardRef as ReactComponent };